import Vue from "vue";
import Vuex from "vuex";

// system
import navCollection from "./modules/navCollection.js";
import auth from "./modules/auth.js";
import flow from "./modules/flow.js";
import auth_oc from "./modules/auth_oc.js";
import member from "./modules/member.js";
import path from "./modules/path.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    navCollection,
    auth,
    flow,
    auth_oc,
    member,
    path
  }
  // strict: true
});
